import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";  

import bgEntreprise from "../assets/Service-entreprise.jpg";
import "./Entreprises.css";

// Import des images du catalogue
import cat1 from "../assets/cat1.jpg";
import cat2 from "../assets/cat2.jpg";
import cat3 from "../assets/cat3.jpg";
import cat4 from "../assets/cat4.jpg";
import cat6 from "../assets/cat6.jpg";
import cat7 from "../assets/cat7.jpg";

export default function Entreprises() {
  const navigate = useNavigate();

  // 🟦 LISTE DES CARTES SERVICES
  const cards = [
    "Professionele schoonmaak van trappenhuizen",
    "Schoonmaak van kantoren",
    "Professioneel schoonmaakonderhoud",
    "Glazenwasservice",
    // "Nettoyage et entretien des porches pour VVE",
    "Specialistische reiniging",
    "Reiniging van bouwprojecten"
  ];

  return (
    <div>

      {/* === HERO AVEC HEADER === */}
      <div
        className="hero-entreprises"
        style={{
          backgroundImage: `
            linear-gradient(
              rgba(0, 195, 300, 0.70),
              rgba(0, 175, 200, 0.75)
            ),
            url(${bgEntreprise})
          `,
        }}
      >
        <Header />
        


        <div className="hero-title">
          <h1>Zakelijke diensten</h1>
        </div>
      </div>

      {/* === CONTENU DE LA PAGE === */}
      <div className="entreprises-content">

        {/* Colonne gauche */}
        <div className="left-column">
          <h1 className="big-title">
            Een altijd onberispelijk kantoor – flexibele werktijden die bij u passen
          </h1>

          <h2 className="subtitle">
            Uw partner voor regelmatige schoonmaak, voor dagelijks, wekelijks of periodiek onderhoud
          </h2>

          <p className="text">
            Uw medewerkers verdienen een gezonde en aangename werkomgeving, en uw bezoekers een onberispelijke eerste indruk. Directschoon biedt een dagelijkse, wekelijkse of periodieke schoonmaakdienst die perfect is afgestemd op uw planning.
          </p>

          <div className="left-bottom">
            <button className="btn-entreprise" onClick={() => navigate("/devis")}>Gratis offerte aanvragen</button>
            <p className="questions">Vragen? Bel 06 41 41 61 69</p>
          </div>
        </div>

        {/* Colonne droite */}
        <div className="right-column">
            <h2 className="why-title">Waarom Directschoon?</h2>

            <ul className="why-list">

                <li>
                  <span className="icon">✔️</span>
                  <div>
                      <h3>Betrouwbaarheid en continuïteit</h3>
                      <p>
                        Bij ziekte of vakantie wordt er onmiddellijk voor vervanging gezorgd; de schoonmaak wordt nooit geannuleerd.
                      </p>
                  </div>
                </li>

                <li>
                  <span className="icon">✔️</span>
                  <div>
                      <h3>Vast aanspreekpunt en snelle communicatie</h3>
                      <p>
                        Direct contact via 06 41 41 61 69, van maandag tot en met vrijdag van 9.00 tot 17.00 uur.
                      </p>
                  </div>
                </li>

                <li>
                  <span className="icon">✔️</span>
                  <div>
                      <h3>Gegarandeerde kwaliteit</h3>
                      <p>
                        Periodieke inspecties en gecertificeerde specialisten voor glasbewassing, dieptereiniging en nog veel meer.
                      </p>
                  </div>
                </li>

                <li>
                  <span className="icon">✔️</span>
                  <div>
                      <h3>De Cleanriders-fietsteams in het stadscentrum</h3>
                      <p>
                        Zeer snelle levering ter plaatse, zonder parkeerkosten en milieuvriendelijk.
                      </p>
                  </div>
                </li>

                <li>
                  <span className="icon">✔️</span>
                  <div>
                      <h3>Duurzame aanpak</h3>
                      <p>
                        Milieuvriendelijke producten en methoden, waar mogelijk.
                      </p>
                  </div>
                </li>

            </ul>
        </div>
      </div>

      {/* ==== SECTION SERVICES AUX ENTREPRISES ==== */}
      <div className="catalogue-section-entreprise">
        <h2 className="section-title">Onze zakelijke diensten</h2>

        <div className="catalogue-grid">
            {cards.map((card, index) => (
              <div className="catalogue-card" key={index}>
                
                {/* Sélection automatique de l’image correspondant au titre */}
                <img
                  src={[cat1, cat2, cat3, cat4, cat6, cat7][index]}
                  alt={card}
                  className="catalogue-card-image"
                />

                <h3>{card}</h3>
                <button className="en-savoir-plus">Meer weten</button>
              </div>
            ))}
        </div>
      </div>

      <Footer />

    </div>
  );
}
